import axios from 'axios'
import global from '@/assets/js/global.js'
import router from '../router'
export function fetch(url, param, config, judge) {
  let _param = param || {};
  // 补足接口的“/”
  url = url.substr(0, 1) == '/' ? url : '/' + url;
  return new Promise((resolve, reject) => {
    // judge  ==> 判断是post还是get请求
    if (judge) {
      // get请求
      let par = {
        params: _param,
      }
      axios.get(global.baseURL + url, par).then(response => {
        // 回调
        resolve(response.data)
      }, err => {
        console.error('接口报错！', err)
      });
    } else {
      // post请求
      axios.post(global.baseURL + url, _param).then(response => {
        // 回调
        resolve(response.data)
      }, err => {
        console.error('接口报错！', err)
      })
    }
  })
}


// WEBPACK FOOTER //
// ./src/axios/index.js